import React from 'react'

function MtoPopup() {
  return (
   <main className="measurement-wrap">
  <header className="measurement-header">
    <h1>MADE TO MEASURE ORDERS</h1>
    <p> Order in your size. Pay in 3 stages (50% / 25% / 25%),<br />
      with photo &amp; video updates throughout. </p>
  </header>
  <section className="process">
    <article className="step step-1 highlight">
      <div className="number">1</div>
      <h2>Place Your<br />
        Order</h2>
      <div className="payment">50% PAYMENT</div>
      <div className="underline"></div>
      <div className="arrow arrow-right"></div>
    </article>
    <article className="step step-2">
      <div className="number">2</div>
      <h2>Fabric &amp;<br />
        Embroidery</h2>
      <p>carefully ordered</p>
      <div className="underline"></div>
      <div className="arrow arrow-right"></div>
    </article>
    <article className="step step-3 highlight">
      <div className="number">3</div>
      <h2>Materials<br />
        Ready</h2>
      <div className="payment">25% PAYMENT</div>
      <p>Photos shared; video<br />
        call can be arranged.</p>
      <div className="arrow arrow-bottom"></div>
    </article>
    <article className="step step-4">
      <div className="number">4</div>
      <h2>Stitching</h2>
      <p>your piece takes shape</p>
      <div className="underline"></div>
      <div className="arrow arrow-left"></div>
    </article>
    <article className="step step-5">
      <div className="number">5</div>
      <h2>Finishing</h2>
      <p>every detail refined</p>
      <div className="underline"></div>
      <div className="arrow arrow-left"></div>
    </article>
    <article className="step step-6">
      <div className="number">6</div>
      <h2>Quality Check</h2>
      <p>inspected with care</p>
      <div className="underline"></div>
      <div className="arrow arrow-bottom"></div>
    </article>
    <article className="step step-7">
      <div className="number">7</div>
      <h2>Outfit Ready</h2>
      <p>crafted just for you</p>
      <div className="underline"></div>
      <div className="arrow arrow-right"></div>
    </article>
    <article className="step step-8 final">
      <div className="number">8</div>
      <h2>Final Approval</h2>
      <div className="payment">25% BALANCE PAYMENT</div>
      <p>Detailed photos &amp;<br />
        videos shared to confirm.</p>
      <div className="arrow arrow-right"></div>
    </article>
    <article className="step step-9 dispatch">
      <div className="number">9</div>
      <h2>Dispatch</h2>
      <p>on its way to you</p>
      <div className="arrow-line"></div>
    </article>
  </section>
  <section className="promise">
    <div className="promise-icon"></div>
    <div>
      <h3 className="promise-title">OUR MEASUREMENT PROMISE</h3>
      <p className="promise-text"> After your order is placed, we’ll guide you through our easy DIY measurement process. </p>
    </div>
  </section>
  <div className="footer-title">CRAFTED WITH CARE</div>
</main>

  )
}

export default MtoPopup
